@if (isHeaderVisible) {
  <div
    class="header topfan-header-host"
    [ngStyle]="{
      visibility: isWhiteLabelDataLoading ? 'hidden' : 'visible'
    }"
  >
    @if (showWhiteLabelMobileChrome) {
      <div class="topfan-header-host__wl-chrome">
        @if (whitelabelUserData?.email | isMyProfile) {
          <div class="whiteLabel-profile profileImage">
            <div class="profileImage">
              @if (whitelabelUserData?.profile_image_url) {
                <img
                  appDisableRightClick
                  appMobileOptimization
                  [originalUrl]="whitelabelUserData?.profile_image_url"
                  [src]="whitelabelUserData?.profile_image_url"
                  [alt]="headerHostLabels.PROFILE_IMAGE_ALT"
                  loading="lazy"
                  decoding="async"
                />
              }
            </div>
          </div>
        }
        @if (whitelabelUserData && backBtnDetails) {
          <a
            [routerLink]="[backBtnDetails?.routerLink]"
            class="icon-back-whitelabel"
          >
            <em class="icon-arrow-back"></em>
          </a>
        }
      </div>
    }
    <app-header-layout
      [data]="headerLayoutData"
      [showDefaultTopFanLogo]="!isWhitelabel"
      [isProPageLogo]="isAtProHomePage"
      [pinToViewport]="true"
      [overlayOnHero]="showTopFanMarketingNav"
      [hideGuestAuthCtas]="hideHeaderGuestAuthCtas"
      [allowMobileGetStarted]="showWhiteLabelMobileGetStarted"
      [compactCtas]="scrSize <= screenSize.mobile"
      [style.--header-layout-pin-top]="headerLayoutPinTop"
      [userMenuTemplate]="headerUserMenuTemplate"
      (brandClick)="onRoute()"
    >
      <ng-template #headerUserMenuTemplate>
        @if (authService.hasStoredSession() || authService.isAuthenticated()) {
          <app-header-user-menu
            [themeColor]="themeColor"
            [backgroundColor]="backgroundColor"
            [isMarketingPageVisible]="isMarketingPageVisible"
            (menuOpenChange)="onHeaderOpen($event)"
          ></app-header-user-menu>
        }
      </ng-template>
      <div headerLayoutActions class="topfan-header-actions">
        @if (
          authService.isLogin &&
          (((permissionKeys.NEW_POST | hasPermission | async) &&
            (permissionKeys.MAKE_EDIT_FEED_POSTS
              | hasPermission: PERMISSION_TYPE.READ : true
              | async) &&
            !isWhitelabel) ||
            (!isWhitelabel && userProfileData?.is_host_owner) ||
            (isWhitelabel &&
              userProfileData?.gsi4pk === whitelabelUserData?.gsi4pk)) &&
          (userProfileData | showTabByApproval: sidebarTabs.NEW_POST)
        ) {
          <a [routerLink]="['/dashboard/newpost']" class="newpost-icon">
            <em class="icon-res-newpost"></em>
          </a>
        }
        @if (
          authService.isLogin &&
          (((permissionKeys.NEW_POST | hasPermission | async) &&
            !userProfileData?.delegate_user?.type?.length &&
            (permissionKeys.MAKE_EDIT_FEED_POSTS
              | hasPermission: PERMISSION_TYPE.READ : true
              | async) &&
            !isWhitelabel) ||
            (!isWhitelabel && userProfileData?.is_host_owner) ||
            (isWhitelabel &&
              userProfileData?.gsi4pk === whitelabelUserData?.gsi4pk)) &&
          (userProfileData | showTabByApproval: sidebarTabs.LIVE_STREAM)
        ) {
          <a (click)="navigateToLiveStream()" class="newpost-icon">
            <em class="icon-liteVideo-1"></em>
          </a>
        }
        @if (showMarketingGuestCtas) {
          <div class="marketing-page-ctas header-guest-chrome">
            <div class="marketing-page-ctas__desktop">
              <div
                class="features-dropdown-wrapper marketing-page-ctas--desktop-only"
              >
                <a
                  class="marketing-page-cta header-marketing-cta features-toggle-btn"
                  (click)="toggleFeaturesDropdown($event)"
                >
                  <span class="marketing-page-cta__text">
                    {{ AUTH_CONSTANTS.Features }}
                  </span>
                  <svg
                    class="features-chevron"
                    [ngClass]="{
                      'features-chevron--open': isFeaturesDropdownOpen
                    }"
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </div>
              @if (PAGE_COMPARISONS?.length) {
                <div
                  class="features-dropdown-wrapper marketing-page-ctas--desktop-only"
                >
                  <a
                    class="marketing-page-cta header-marketing-cta features-toggle-btn"
                    (click)="toggleCompareDropdown($event)"
                  >
                    <span class="marketing-page-cta__text">
                      {{ AUTH_CONSTANTS.COMPARE }}
                    </span>
                    <svg
                      class="features-chevron"
                      [ngClass]="{
                        'features-chevron--open': isCompareDropdownOpen
                      }"
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              }
              @if (showCreatorsCta) {
                <a
                  class="marketing-page-cta header-marketing-cta"
                  (click)="navigateToCreators()"
                >
                  <span class="marketing-page-cta__text d-none d-lg-block">
                    {{ CREATORS_CONST.CREATE_ON_TOPFANS }}
                  </span>
                  <span class="marketing-page-cta__text d-lg-none">
                    {{ CREATORS_CONST.CREATORS }}
                  </span>
                </a>
              }
              @if (showMarketingPageCtas) {
                <a
                  class="marketing-page-cta header-marketing-cta"
                  (click)="navigateToRequestADemo()"
                >
                  <span class="marketing-page-cta__text">
                    {{ CREATORS_CONST.REQUEST_DEMO }}
                  </span>
                </a>
              }
              @if (showMarketingPageCtas && !isAtProHomePage) {
                <a
                  class="marketing-page-cta header-marketing-cta"
                  (click)="applyToJoin()"
                >
                  <span class="marketing-page-cta__text d-none d-lg-block">
                    {{ CREATORS_CONST.APPLY_NOW }}
                  </span>
                  <span class="marketing-page-cta__text d-lg-none">
                    {{ CREATORS_CONST.APPLY }}
                  </span>
                </a>
              }
            </div>
          </div>
        }
      </div>
      @if (showMarketingGuestCtas) {
        <div
          headerLayoutTrailing
          class="marketing-kebab-wrapper marketing-page-ctas__mobile header-guest-chrome"
          (click)="toggleMarketingKebabMenu($event)"
        >
          <button
            type="button"
            class="marketing-kebab-btn"
            [attr.aria-label]="headerLabels.MORE_OPTIONS"
            [attr.aria-expanded]="isMarketingKebabMenuOpen"
          >
            <em class="icon-litemenu-icon"></em>
          </button>
        </div>
      }
      @if (
        authService.isAuthenticatedAndConfirmed &&
        (userProfileData | showTabByApproval: sidebarTabs.MESSAGES)
      ) {
        <a
          headerLayoutTrailing
          [routerLink]="['/messages']"
          class="message-icon"
          [attr.aria-label]="headerLabels.MESSAGES"
        >
          <em class="icon-message"></em>
          @if (messageCount) {
            <div class="sidebar-nav-notification">
              {{ messageCount }}
            </div>
          }
        </a>
      }
    </app-header-layout>
    @if (isFeaturesDropdownOpen) {
      <div class="features-dropdown-panel">
        @for (category of PAGE_FEATURES; track category) {
          <a
            class="features-dropdown-card"
            rel="noopener noreferrer"
            (click)="closeFeaturesDropdown(category)"
          >
            <div class="features-dropdown-card__img">
              <img
                appDisableRightClick
                appMobileOptimization
                [originalUrl]="category.imageUrl"
                [src]="category.imageUrl"
                [alt]="category.title"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div class="features-dropdown-card__title">
              {{ category.title }}
            </div>
            <div class="features-dropdown-card__link">
              {{ AUTH_CONSTANTS.EXPLORE_FEATURES }}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3.333 8h9.334M8.667 4l4 4-4 4"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </a>
        }
      </div>
    }
    @if (isCompareDropdownOpen) {
      <div class="features-dropdown-panel comparison-dropdown-panel">
        @for (comparison of PAGE_COMPARISONS; track comparison) {
          <a
            class="features-dropdown-card comparison-dropdown-card"
            rel="noopener noreferrer"
            (click)="closeCompareDropdown(comparison)"
          >
            <div class="features-dropdown-card__img comparison-logo">
              <img
                appDisableRightClick
                appMobileOptimization
                [originalUrl]="comparison.competitor_logo"
                [src]="comparison.competitor_logo"
                [alt]="comparison.title"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div class="features-dropdown-card__link">
              {{ AUTH_CONSTANTS.EXPLORE_COMPARISON }}
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3.333 8h9.334M8.667 4l4 4-4 4"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </a>
        }
      </div>
    }
    @if (isMarketingKebabMenuOpen) {
      <div
        class="marketing-kebab-backdrop"
        (click)="closeMarketingKebabMenu()"
      ></div>
    }
    @if (isMarketingKebabMenuOpen) {
      <div class="marketing-kebab-menu">
        <button
          type="button"
          class="marketing-kebab-menu__item"
          (click)="openFeaturesFromKebab($event)"
        >
          {{ AUTH_CONSTANTS.Features }}
        </button>
        @if (PAGE_COMPARISONS?.length) {
          <button
            type="button"
            class="marketing-kebab-menu__item"
            (click)="openCompareFromKebab($event)"
          >
            {{ AUTH_CONSTANTS.COMPARE }}
          </button>
        }
      </div>
    }
  </div>
}

<app-creator-requirements-modal
  #creatorsRequirementModal
  [isCreatorsHomePage]="true"
></app-creator-requirements-modal>
